import { api } from "@/lib/api";

export interface HealthConnectSyncResult {
  success: boolean;
  syncedDays: number;
  error?: string;
  authFailed?: boolean;
  backgroundAccessDenied?: boolean;
}

export interface HealthConnectPermissionResult {
  granted: boolean;
  backgroundAccessGranted?: boolean;
  error?: string;
}

export async function getHealthConnectConnectionStatus(): Promise<{
  connected: boolean;
  lastSyncAt: string | null;
}> {
  type StatusResponse = { connected: boolean; lastSyncAt: string | null };
  const res = await api.get<StatusResponse>("/sync/health-connect/status");
  if (res.error) {
    return { connected: false, lastSyncAt: null };
  }
  return res.data as StatusResponse;
}

export async function disconnectHealthConnect(): Promise<{ success: boolean; error?: string }> {
  const res = await api.post("/sync/health-connect/disconnect");
  if (res.error) {
    return { success: false, error: res.error.message };
  }
  return { success: true };
}
